<div id="SEOC" class="home-tab-container">
    <input id="tab-one" type="radio" name="grp" checked="checked" /><label for="tab-one">Benefits</label>
    <div id="benefits" class="home-tab-content vehicleBenefits">
        <div>
            <div>
                <h2 class="ins-heading pt-10">
                    Features/ Benefits
                </h2>
            </div>
            <div>
                <h2 class="ins-heading pt-10">
                    Cashless claim settlement at 4,500+ partner network garages
                </h2>
            </div>
            <div class="ins-answer pt-10 margin6">
                <p>
                    Repair your damaged two-wheeler across 4,500+ partner network garages and avail of cashless claim
                    facilities.
                </p>
            </div>
            <div>
                <h2 class="ins-heading pt-10">
                    Own-damage coverage
                </h2>
            </div>
            <div class="ins-answer pt-10 margin6">
                <p>
                    An own damage plan, covers your own insured vehicle against damages caused due to natural
                    calamities, theft, fire, and accidents.
                </p>
            </div>
            <div>
                <h2 class="ins-heading pt-10">
                    Comprehensive cover
                </h2>
            </div>
            <div class="ins-answer pt-10 margin6">
                <p>
                    Comprehensive plans give the insured vehicle the double advantage of both own damage as well as
                    third-party liability coverage.
                </p>
            </div>
            <div>
                <h2 class="ins-heading pt-10">
                    Multiple optional add-on covers
                </h2>
            </div>
            <div class="ins-answer pt-10 margin6">
                <p>
                    Choose from multiple add-on covers: loss of accessories, legal liability to paid driver, cleaner, or
                    any workman, and personal accident cover for occupants.
                </p>
            </div>
            <div>
                <h2 class="ins-heading pt-10">
                    Add Ons
                </h2>
            </div>
            <div>
                <h3 class="ins-heading pt-10">
                    24/7 Spot Assistance
                </h3>
            </div>
            <div class="ins-answer pt-10 margin6">
                <p>
                    Ensure you are never stranded on the road due to any problem associated with your two-wheeler by
                    getting help for problems like tyre change, assistance for the two-wheeler’s engine, or assistance
                    in settling in an accident with just a call away regardless of the situation where you are stuck.
                </p>
            </div>
            <div>
                <h3 class="ins-heading pt-10">
                    Helmet Cover
                </h3>
            </div>
            <div class="ins-answer pt-10 margin6">
                <p>
                    If your helmet is partially damaged, get cover for the repair or replacement of the helmet damaged
                    in the accident.
                </p>
            </div>
            <div>
                <h3 class="ins-heading pt-10">
                    Depreciation Shield
                </h3>
            </div>
            <div class="ins-answer pt-10 margin6">
                <p>
                    Nullify the depreciation associated with the two-wheeler, by not losing the value in the market. Get
                    this add-on for your two-wheeler and all its spare parts. Highly, recommended for your two-wheelers
                    older than 5 years.
                </p>
            </div>
            <div>
                <h3 class="ins-heading pt-10">
                    Engine Protector
                </h3>
            </div>
            <div class="ins-answer pt-10 margin6">
                <p>
                    Protect your most crucial two-wheeler parts by getting paid for expenses arising due to water
                    ingression, oil leakage, hydrostatic look, and more. Additionally, get cover for damages to the gear
                    box, and gearbox parts too.
                </p>
            </div>
            <div>
                <h3 class="ins-heading pt-10">
                    Personal Accident Cover for pillion Rider
                </h3>
            </div>
            <div class="ins-answer pt-10 margin6">
                <p>
                    Indemnify the loss or damage of the two where the safety of a pillion rider is not sacrificed. Get a
                    pillion rider cover where you protect secondary rider who was riding with you at the time of the
                    accident.
                </p>
            </div>
        </div>
    </div>
    <input id="tab-two" type="radio" name="grp"  /><label for="tab-two">Overview</label>
    <div id="overview" class="home-tab-content overview">
        <div>
            <div class="ins-answer ">
                <p class="">
                    Having a vehicle of your own means you can travel conveniently and comfortably but it also brings
                    with it responsibilities.
                    Ensuring traffic rules are followed, safe driving habits, maintenance of the vehicle, all of this
                    becomes essential.
                    Even after taking all the precautions, road accidents can happen at any time for various reasons.
                </p>
                <p class="">
                    To keep you safeguarded against these damages and losses, Bajaj Finance Limited (BFL) brings you
                    attractive plans
                    that come with valuable add-ons that your vehicle needs. With our partner relationships with some of
                    the best
                    names in the Motor Insurance segment, we not just give you plans to suit your needs but also offer
                    some great
                    advantages like, depreciation cover, engine cover, 24*7 roadside assistance, and towing facility.
                </p>
                <p class="">
                    So, select the plan that complies with your needs and helps you manage your vehicle better on the
                    roads.
                </p>
            </div>
        </div>
    </div>
    <input id="tab-three" type="radio" name="grp" /><label for="tab-three">FAQs</label>
    <div id="faqs" class="home-tab-content vehicleFaq faqs">
        <div class="faq-details">
            <h3 #ques1 (click)="openAnswer(ques1)" class="ques">Is Motor Insurance Mandatory?
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
                    class="plus bi bi-plus" viewBox="0 0 16 16">
                    <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor"
                    stroke-weight="2" class="minus bi bi-dash" viewBox="0 0 16 16">
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
            </h3>
            <p id="ans1" class="ans">
                Yes, section 146 of Motor Vehicle Act 1988 mandates that no vehicle can ply on road without insurance
                against third party risks. Hence it is compulsory to get Third Party insurance to cover the liabilities
                in event of injury/ death of third party or damage of property of third party.
            </p>
        </div>
        <div class="faq-details">
            <h3 #ques2 (click)="openAnswer(ques2)" class="ques">How many types of motor insurance are there in India?
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
                    class="plus bi bi-plus" viewBox="0 0 16 16">
                    <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor"
                    stroke-weight="2" class="minus bi bi-dash" viewBox="0 0 16 16">
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
            </h3>
            <p id="ans2" class="ans">
                There are two types of motor insurance in India Third party insurance and comprehensive insurance.
            </p>
        </div>
        <div class="faq-details">
            <h3 #ques3 (click)="openAnswer(ques3)" class="ques">What is third-party motor insurance?
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
                    class="plus bi bi-plus" viewBox="0 0 16 16">
                    <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor"
                    stroke-weight="2" class="minus bi bi-dash" viewBox="0 0 16 16">
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
            </h3>
            <p id="ans3" class="ans">
                Third Party motor insurance is type of policy which covers any liabilities arising in case of injury or
                death of third party or damage to third party property caused by insured vehicle.
            </p>
        </div>
        <div class="faq-details">
            <h3 #ques4 (click)="openAnswer(ques4)" class="ques">What is a comprehensive motor insurance policy?
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
                    class="plus bi bi-plus" viewBox="0 0 16 16">
                    <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor"
                    stroke-weight="2" class="minus bi bi-dash" viewBox="0 0 16 16">
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
            </h3>
            <p id="ans4" class="ans">
                Comprehensive motor insurance covers both third-party liability and damages to your vehicle as well.
            </p>
        </div>
        <div class="faq-details">
            <h3 #ques5 (click)="openAnswer(ques5)" class="ques">What is Zero-Depreciation cover?
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
                    class="plus bi bi-plus" viewBox="0 0 16 16">
                    <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor"
                    stroke-weight="2" class="minus bi bi-dash" viewBox="0 0 16 16">
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
            </h3>
            <p id="ans5" class="ans">
                This cover provides the policyholder complete claim amount on the value of replaced parts without
                deducting any depreciation, following an accident. However, this cover is available only for vehicles
                that are less than three years old.
            </p>
        </div>
        <div class="faq-details">
            <h3 #ques6 (click)="openAnswer(ques6)" class="ques">What is NCB protection cover?
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
                    class="plus bi bi-plus" viewBox="0 0 16 16">
                    <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor"
                    stroke-weight="2" class="minus bi bi-dash" viewBox="0 0 16 16">
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
            </h3>
            <p id="ans6" class="ans">
                No Claim Bonus (NCB) is given for not making any claims during the policy term. As the name suggests,
                the benefit doesn’t nullify the NCB in the event of a claim; it brings down the slab at which the NCB
                discount is given on premium.
            </p>
        </div>
        <div class="faq-details">
            <h3 #ques7 (click)="openAnswer(ques7)" class="ques">What is Return on Invoice Cover?
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
                    class="plus bi bi-plus" viewBox="0 0 16 16">
                    <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor"
                    stroke-weight="2" class="minus bi bi-dash" viewBox="0 0 16 16">
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
            </h3>
            <p id="ans7" class="ans">
                Under this cover, if there’s theft or damages beyond repair it provides you the benefit where you can
                get back the complete amount of your car/bike invoice value, including the cost of registering a new
                vehicle and its road tax, respectively.
            </p>
        </div>
        <div class="faq-details">
            <h3 #ques8 (click)="openAnswer(ques8)" class="ques">What is Road-side Assistance Cover?
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
                    class="plus bi bi-plus" viewBox="0 0 16 16">
                    <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor"
                    stroke-weight="2" class="minus bi bi-dash" viewBox="0 0 16 16">
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
            </h3>
            <p id="ans8" class="ans">
                Under this roadside assistance cover, you can call the support team and they will provide you the
                support for your vehicle on the spot, and repair your vehicle.
            </p>
        </div>
        <div class="faq-details">
            <h3 #ques9 (click)="openAnswer(ques9)" class="ques">What is IDV for bike insurance?
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
                    class="plus bi bi-plus" viewBox="0 0 16 16">
                    <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor"
                    stroke-weight="2" class="minus bi bi-dash" viewBox="0 0 16 16">
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
            </h3>
            <p id="ans9" class="ans">
                IDV or Insured Declared Value for bike insurance means the current market value of the vehicle. It
                corresponds to the maximum sum assured fixed on the vehicle that is paid against total loss or theft of
                the bike.
            </p>
        </div>
        <div class="faq-details">
            <h3 #ques10 (click)="openAnswer(ques10)" class="ques">When & how will I get my two wheeler insurance policy
                if I buy it online?
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
                    class="plus bi bi-plus" viewBox="0 0 16 16">
                    <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor"
                    stroke-weight="2" class="minus bi bi-dash" viewBox="0 0 16 16">
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
            </h3>
            <p id="ans10" class="ans">
                Insurers usually send the soft copy of the two wheeler insurance policy on the email id that you
                provide. You should receive the policy almost immediately after you pay your two-wheeler insurance
                premium online.
            </p>
        </div>
        <div class="faq-details">
            <h3 #ques11 (click)="openAnswer(ques11)" class="ques">What is the advantage of purchasing a two-wheeler
                insurance online?
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
                    class="plus bi bi-plus" viewBox="0 0 16 16">
                    <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor"
                    stroke-weight="2" class="minus bi bi-dash" viewBox="0 0 16 16">
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
            </h3>
            <p id="ans11" class="ans">
                Purchasing a two-wheeler insurance online helps you save time and hassle and the purchase can be done
                from anywhere, anytime.
            </p>
        </div>
    </div>
</div>